// Payer / non-payer advisor routing for phone and video (Dien 2026-10-15,
// Aziz 2026-10-16; flow/scheduling/advisor_tiers.py). Every advisor payload
// (/agents/, the returning-client lookup) carries the two switches from the
// users page, `agent_takes_payers` and `agent_takes_non_payers`; both
// schedulers use this to keep only the advisors who meet the client's tier. An
// unknown tier, or an advisor without the switches (an older payload), is
// never filtered out. /book/ judges for itself either way.
export function agentTakesTier (agent, payer) {
    if (payer === null || payer === undefined || !agent) return true
    const flag = payer ? agent.agent_takes_payers : agent.agent_takes_non_payers
    return flag !== false
}
